import qs from 'qs';

export const isFunction = func =>
  func && {}.toString.call(func) === '[object Function]';

export const parseParams = url => {
  const [path, paramString] = url.split('?');
  return [path, paramString ? qs.parse(paramString) : {}];
};

export const mergeParams = (override = true) => (...args) =>
  args.filter(Boolean).reduce((params, arg) => {
    Object.keys(arg).forEach(param => {
      params[param] =
        params[param] && !override
          ? Array.isArray(params[param])
            ? [arg[param], ...params[param]]
            : [arg[param], params[param]]
          : arg[param];
    });
    return params;
  }, {});

// parses values with || and returns either or depending on the passed boolean
export const eitherOr = bool => val => {
  const value = Array.isArray(val) ? val : [val];
  const either = value[0];
  const or = value[1];
  const condition = bool ? either : or;
  return or === undefined ? either : condition;
};

const isBoolean = value => typeof value === 'boolean';

export const trackingURL = (
  href,
  key = '',
  conditions = {},
  options = {
    encode: true,
    arrayFormat: 'repeat', // 'a=b&a=c',
  }
) => tracking => {
  const [path, params] = parseParams(href);

  const paramsWithTrackings = mergeParams(true)(
    params,
    tracking[key] || tracking[path.replace('/', '')] // fallback to url match if key is not specified
  );

  const updatedParams = Object.keys(paramsWithTrackings).reduce((obj, key) => {
    const value = isFunction(conditions[key])
      ? conditions[key](paramsWithTrackings[key])
      : isBoolean(conditions[key])
      ? eitherOr(conditions[key])(paramsWithTrackings[key])
      : paramsWithTrackings[key];

    return { ...obj, [key]: value };
  }, {});

  const queryString = qs.stringify(updatedParams, options);

  return queryString.length ? `${path}?${queryString}` : path;
};
